<app-simulasyon-banner></app-simulasyon-banner>

<p-toast position="top-left" key="tl"></p-toast>
<p-toast position="top-right" key="tr" [baseZIndex]="10000"></p-toast>

<p-toast position="top-center" key="tc"></p-toast>
<p-toast position="bottom-center" key="bc"></p-toast>
<p-toast position="bottom-right" key="br"></p-toast>
<router-outlet></router-outlet>
